import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the home state domain
 */

const selectHomeDomain = (state) =>
  state.get("AdministratorUsersHome", initialState)

export const makeSelectIsLoading = () =>
  createSelector(selectHomeDomain, (state) => state.get("isLoading"))

export const makeSelectCompaniesAccessLoading = () =>
  createSelector(selectHomeDomain, (state) =>
    state.get("companiesAccessLoading")
  )

export const makeSelectUsers = () =>
  createSelector(selectHomeDomain, (state) => state.get("users"))

export const makeSelectUserCreate = () =>
  createSelector(selectHomeDomain, (state) => state.get("user_create"))

export const makeSelectSaveLoading = () =>
  createSelector(selectHomeDomain, (state) => state.get("save_loading"))

export const makeSelectOptions = () =>
  createSelector(selectHomeDomain, (state) => state.get("options"))

const makeSelectHome = () =>
  createSelector(selectHomeDomain, (substate) => substate.toJS())

export default makeSelectHome
export { selectHomeDomain }
